module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    class: {
      modal: true, fade: true, in: _vm.show
    },
    style: ({
      display: _vm.show ? 'block' : 'none'
    }),
    attrs: {
      "id": _vm.id
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("\n          " + _vm._s(_vm.title) + "\n        ")])]), _vm._v(" "), ('players' === _vm.type) ? _c('div', {
    staticClass: "modal-body"
  }, [_c('table', _vm._l((_vm.data.players), function(player) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "display": "flex",
        "align-items": "center"
      }
    }, [_c('icon', {
      attrs: {
        "code": player.code
      }
    }), _vm._v(" "), _c('h4', [_vm._v(_vm._s(player.name) + ":")])], 1), _vm._v(" "), _c('td', {
      staticClass: "t-col"
    }, [_vm._v(_vm._s(player.terrCount) + " Territories")]), _vm._v(" "), _c('td', {
      staticClass: "c-col"
    }, [_vm._v(_vm._s(player.cards.length) + " " + _vm._s(player.cards.length === 1 ? "card" : "cards"))])])
  }), 0), _vm._v(" "), _c('span', [_vm._v("A set of cards is worth " + _vm._s(_vm.data.cardValue) + " troops.")])]) : (['cards', 'turnInCards'].includes(_vm.type)) ? _c('div', {
    staticClass: "modal-body"
  }, [(_vm.type === 'turnInCards') ? _c('div', [_c('label', [_vm._v("Please select three cards to turn in: ")])]) : _vm._e(), _vm._v(" "), (_vm.data.cards.length > 0) ? _c('div', {
    staticClass: "cardBox"
  }, _vm._l((_vm.data.cards), function(card, key) {
    return _c('card', {
      key: key,
      attrs: {
        "value": card + 1,
        "index": key,
        "clickHandler": _vm.selectCard
      }
    })
  }), 1) : _c('div', [_c('i', [_vm._v("You do not have any cards!")])]), _vm._v(" "), _c('span', {
    staticClass: "right"
  }, [_c('i', [_vm._v(_vm._s(_vm.error))])])]) : ('passTroops' === _vm.type) ? _c('div', {
    staticClass: "modal-body"
  }, [_c('label', [_vm._v("Enter number of Troops to pass:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.troops),
      expression: "troops",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "id": "troops",
      "type": "number",
      "min": _vm.data.min,
      "max": _vm.data.max
    },
    domProps: {
      "value": (_vm.troops)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.troops = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("This will leave behind:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.behind))]), _c('br'), _vm._v(" "), _c('i', {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm.error))])]) : (['dicepick1', 'dicepick2'].includes(_vm.type)) ? _c('div', {
    staticClass: "modal-body center"
  }, [_c('p', [_vm._v(_vm._s(_vm.content))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dice),
      expression: "dice"
    }],
    attrs: {
      "type": "radio",
      "id": "one"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.dice, 1)
    },
    on: {
      "change": function($event) {
        _vm.dice = 1
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "one"
    }
  }, [_vm._v("One")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dice),
      expression: "dice"
    }],
    attrs: {
      "type": "radio",
      "id": "two"
    },
    domProps: {
      "value": 2,
      "checked": _vm._q(_vm.dice, 2)
    },
    on: {
      "change": function($event) {
        _vm.dice = 2
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "two"
    }
  }, [_vm._v("Two")]), _vm._v(" "), (_vm.data.threeDice) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dice),
      expression: "dice"
    }],
    attrs: {
      "type": "radio",
      "id": "three"
    },
    domProps: {
      "value": 3,
      "checked": _vm._q(_vm.dice, 3)
    },
    on: {
      "change": function($event) {
        _vm.dice = 3
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.data.threeDice) ? _c('label', {
    attrs: {
      "for": "three"
    }
  }, [_vm._v("Three")]) : _vm._e(), _vm._v(" "), ('dicepick2' === _vm.type) ? _c('div', {
    staticClass: "alwaysRoll"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.autoroll),
      expression: "autoroll"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.autoroll) ? _vm._i(_vm.autoroll, null) > -1 : (_vm.autoroll)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.autoroll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.autoroll = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.autoroll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.autoroll = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Always roll " + _vm._s(_vm.dice === 2 ? "two dice" : "one die") + " and don't ask again")]), _vm._v(" "), _c('br'), _vm._m(0)]) : _vm._e()]) : ('settings' === _vm.type) ? _c('div', {
    staticClass: "modal-body center"
  }, [_c('label', [_vm._v("Your name is: ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    attrs: {
      "type": "text",
      "maxlength": "22",
      "id": "nameInput"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.autoroll),
      expression: "autoroll"
    }],
    attrs: {
      "type": "checkbox",
      "id": "autoroll"
    },
    domProps: {
      "checked": Array.isArray(_vm.autoroll) ? _vm._i(_vm.autoroll, null) > -1 : (_vm.autoroll)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.autoroll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.autoroll = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.autoroll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.autoroll = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "autoroll"
    }
  }, [_vm._v("Auto-roll dice when you are being attacked:")]), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dice),
      expression: "dice"
    }],
    attrs: {
      "type": "radio",
      "id": "two",
      "disabled": !_vm.autoroll
    },
    domProps: {
      "value": 2,
      "checked": _vm._q(_vm.dice, 2)
    },
    on: {
      "change": function($event) {
        _vm.dice = 2
      }
    }
  }), _vm._v(" "), _c('label', {
    class: {
      'disabled': !_vm.autoroll
    },
    attrs: {
      "for": "two"
    }
  }, [_vm._v("Two")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dice),
      expression: "dice"
    }],
    attrs: {
      "type": "radio",
      "id": "one",
      "disabled": !_vm.autoroll
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.dice, 1)
    },
    on: {
      "change": function($event) {
        _vm.dice = 1
      }
    }
  }), _vm._v(" "), _c('label', {
    class: {
      'disabled': !_vm.autoroll
    },
    attrs: {
      "for": "one"
    }
  }, [_vm._v("One")])]) : (_vm.type === 'input') ? _c('div', {
    staticClass: "modal-body"
  }, [_c('label', [_vm._v(_vm._s(_vm.content))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    attrs: {
      "type": "text",
      "maxlength": "22",
      "id": "nameInput"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', [_vm._v(_vm._s(_vm.error))])]) : (_vm.content) ? _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  }), _vm._v(" "), (_vm.data === 'passRules') ? _c('div', [_c('strong', [_vm._v("Rules for passing: ")]), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.showRules
    }
  }, [_vm._v(_vm._s(_vm.rulesShown ? "hide" : "show"))]), _vm._v(" "), (_vm.rulesShown) ? _c('ul', [_c('li', [_vm._v("You have a total of 3 passes - 2 short passes and one long pass (or 3 short passes)")]), _vm._v(" "), _c('li', [_vm._v("A short pass is between 2 of your territories that border each other.")]), _vm._v(" "), _c('li', [_vm._v("A long pass is between 2 of your territories that are connected by a continuous line of territories that you own.")])]) : _vm._e()]) : _vm._e()]) : _c('div'), _vm._v(" "), ('yesno' === _vm.type) ? _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "id": "esc"
    },
    on: {
      "click": _vm.closePopup
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "id": "etr"
    },
    on: {
      "click": _vm.action
    }
  }, [_vm._v("Yes")])]) : ('yesnocancel' === _vm.type) ? _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "id": "esc"
    },
    on: {
      "click": _vm.closePopup
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.action(false)
      }
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "id": "etr"
    },
    on: {
      "click": function($event) {
        return _vm.action(true)
      }
    }
  }, [_vm._v("Yes")])]) : (['input', 'turnInCards', 'settings'].includes(_vm.type)) ? _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "id": "esc"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "id": "etr"
    },
    on: {
      "click": _vm.checkValue
    }
  }, [_vm._v("Ok")])]) : ('dicepick1' === _vm.type) ? _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "id": "esc"
    },
    on: {
      "click": function($event) {
        return _vm.action(0)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "id": "etr"
    },
    on: {
      "click": function($event) {
        return _vm.action(_vm.dice)
      }
    }
  }, [_vm._v("Ok")])]) : ('dicepick2' === _vm.type) ? _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "id": "etr"
    },
    on: {
      "click": _vm.dicepick2
    }
  }, [_vm._v("Ok")])]) : ('confirm' === _vm.type) ? _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "id": "esc"
    },
    on: {
      "click": _vm.closePopup
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.action(false)
      }
    }
  }, [_vm._v("Don't Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "id": "etr"
    },
    on: {
      "click": function($event) {
        return _vm.action(true)
      }
    }
  }, [_vm._v("Save Game")])]) : (['callback', 'cards'].includes(_vm.type)) ? _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "id": "etr"
    },
    on: {
      "click": _vm.action
    }
  }, [_vm._v("Ok")])]) : ('passTroops' === _vm.type) ? _c('div', {
    staticClass: "modal-footer"
  }, [(_vm.title === 'Pass Troops') ? _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "id": "esc"
    },
    on: {
      "click": function($event) {
        return _vm.action(0)
      }
    }
  }, [_vm._v("Cancel")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "id": "etr"
    },
    on: {
      "click": _vm.checkTroops
    }
  }, [_vm._v("Ok")])]) : _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "id": "etr"
    },
    on: {
      "click": _vm.closePopup
    }
  }, [_vm._v("Ok")])])])])]), _vm._v(" "), _c('div', {
    class: {
      'modal-backdrop': _vm.show, in: _vm.show
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._v("You can change this at any time in "), _c('code', [_vm._v("Menu ➜ My Settings")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45145e91"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup.vue
// module id = 197
// module chunks = 0